import { createContext, ReactNode, useContext, useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import { isMobileDevice } from "utils/Functions"

const DeviceContext = createContext<undefined>(undefined)

export const useDevice = () => useContext(DeviceContext)

export function DeviceProvider(prop: { children: ReactNode }) {
    const [canContinue, setCanContinue] = useState<boolean>()

    useEffect(() => {
        setCanContinue(true)
        const tg = (window as any).Telegram;
        if (tg.WebApp.initData) {
            if (isMobileDevice()) {
                tg.WebApp.close()
            }
        } else {
            if (!isMobileDevice()) {
                setCanContinue(false)
            }
        }
    }, [])

    return <DeviceContext.Provider value={undefined}>
        {
            canContinue === undefined && <div style={{ height: "100vh" }} className="w-100 p-2 px-4 d-flex justify-content-center align-items-center">
                <div className="m-auto loader"></div>
            </div>
        }

        {
            canContinue === false && <div className="m-4 alert alert-danger">
                Cannot continue to the app
            </div>
        }


        {canContinue && prop.children}
    </DeviceContext.Provider>
}